
export const fileToBase64 =(file)=>{
    let reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((res,rej)=>{
        reader.onload =  ()=> {
                    res(`${reader.result}`)
        };
        reader.onerror = (error)=>{
          console.error('fileConvertBase64: Error reading file:', {
            error: error.message,
            stack: error.stack,
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type
          });
          rej(error)
        };

    })
}